<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Daily Sold Products</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" md="3">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="date" label="From" prepend-icon="mdi-calendar-month"
                  v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker @change="getRecords" v-model="date" @input="menu1 = false"></v-date-picker>
            </v-menu><br>

            <v-autocomplete autocomplete="off" name="owner" hide-details dense outlined v-model="owner" :items="owners"
              label="Owner" item-text="name" item-value="id" @change="getRecords"></v-autocomplete>
          </v-col>

          <v-col v-if="hideTotals != 'Y' && hideTotalSales != 'Y'" cols="12" offset-md="4" offset-lg="4" md="5"
            class="section-bg">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Shop Sales</td>
                    <td>{{ SalesReportData.TotalShopSales | currency }}</td>
                  </tr>
                  <tr>
                    <td>Outsourced Sales</td>
                    <td>{{ SalesReportData.TotalOutsourcedSales | currency }}</td>
                  </tr>
                  <tr>
                    <td>Total Sales</td>
                    <td>{{ SalesReportData.TotalSales | currency }}</td>
                  </tr>
                  <tr style="color: red">
                    <td>Total Returns</td>
                    <td>{{ TotalReturns | currency }}</td>
                  </tr>
                  <tr style="font-weight: bold">
                    <td>Net Sales</td>
                    <td>{{ netSales | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

        </v-row>


        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
            <!-- start of table -->
            <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers" :items="soldProducts"
              :search="search">
              <!-- template -->
              <template v-slot:item.Price="{ item }">
                {{
                  item.Price.toLocaleString()
                }}
              </template>
              <!-- end -->

              <!-- customer name template -->
              <template v-slot:item.customerPhone="{ item }">
                <span>
                  {{ item.customerName }} - {{ item.customerPhone }}
                </span>
              </template>
              <!-- end -->


              <!-- template -->
              <!-- <template v-slot:item.PaymentModes="{ item }">
               <div v-for="(value, index) in item.document.rct1" v-bind:key="index">
                {{ value.oact.Name }}  {{ value.SumApplied.toLocaleString() }}  ref: {{ value.PaymentRemarks }}
               </div>
              </template> -->
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn color="accent" text :to="`/pos/sale-details/${item.InvoiceId}`">{{ item.DocNum }}</v-btn>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">
                {{
                  item.LineTotal | currency
                }}
              </template>
              <!-- end -->

              <!-- date template -->
                  <template v-slot:item.Date="{ item }">
                <span>{{ formatDateTime(item.Date) }}</span>
              </template>

              <!-- end -->

            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12">
            <h3>Outsourced Products</h3>
          </v-col>

          <v-col cols="12" style="margin-top: -10px">
            <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="outsourcedHeaders"
              :items="outsourcedData" :search="search">

              <!-- action template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn color="accent" text :to="`/pos/sale-details/${item.invoice.id}`">{{ item.invoice.DocNum
                }}</v-btn>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Quantity="{ item }">
                <span>
                  {{
                    item.Quantity.toLocaleString()
                  }}
                </span>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Price="{ item }">
                <span>
                  {{
                    item.Price | currency
                  }}
                </span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">
                <span>
                  {{
                    item.LineTotal | currency
                  }}
                </span>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Date="{ item }">
                <span>
                  {{
                    item.Date | date
                  }}
                </span>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h3 style="color: red">Returned Products</h3>
          </v-col>

          <v-col cols="12" style="margin-top: -30px">
            <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="returnHeaders"
              :items="returnsData" :search="search">
              <!-- template -->
              <template v-slot:item.Quantity="{ item }">
                <span style="color: red">
                  {{
                    item.Quantity.toLocaleString()
                  }}
                </span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.ocrd="{ item }">
                <span style="color: red">{{ item.ocrd.Name }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.product="{ item }">
                <span style="color: red">{{ item.product.Name }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.Price="{ item }">
                <span style="color: red">
                  {{
                    item.Price.toLocaleString()
                  }}
                </span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">
                <span style="color: red">
                  {{
                    item.LineTotal.toLocaleString()
                  }}
                </span>
              </template>
              <!-- end -->
              <template v-slot:item.DocDate="{ item }">
                <span style="color: red">{{ formatDateTime(item.DocDate) }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!--  Products summary dialog -->
        <v-dialog v-model="summaryDialog" max-width="950px">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Products Summary</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="summaryDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12" md="3">
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                          prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                      </template>
                      <v-date-picker v-model="record.StartDate" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" xs="12" md="3">
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field dense outlined single-line v-model="record.EndDate" label="From"
                          prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                      </template>
                      <v-date-picker v-model="record.EndDate" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-checkbox v-model="record.convertToPurchaseUom" label="Purchase Uom"></v-checkbox>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-checkbox v-model="record.allProducts" label="All Products"></v-checkbox>
                  </v-col>

                  <v-col cols="12" md="3" style="margin-top: -40px">
                    <v-btn color="primary" small :loading="loader" @click="getReport">Query Data</v-btn>
                  </v-col>

                  <v-col cols="12" md="3" style="margin-top: -40px">
                    <v-btn text color="accent" @click="printSummary" :loading="loader">
                      <v-icon left color="black">mdi-printer</v-icon>Print
                      Summary
                    </v-btn>

                    <v-btn text color="accent" @click="thermalPrint" :loading="loader">
                      <v-icon left color="black">mdi-printer</v-icon>Print Via
                      Thermal
                    </v-btn>
                  </v-col>

                  <v-col cols="3" style="margin-top: -35px">
                    <!-- excel icon -->
                    <download-excel :data="summaryData" :fields="fields" name="Stock Analysis">
                      <v-icon color="green">mdi-file-excel</v-icon>
                    </download-excel>
                    <!-- end -->
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field label="search" v-model="search"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-data-table :items-per-page="2000" :mobile-breakpoint="0" :headers="summaryHeaders"
                      :items="summaryData" :search="search">
                      <template v-slot:item.TotalLineTotal="{ item }">
                        <span v-if="item.TotalLineTotal >= 0">
                          {{
                            item.TotalLineTotal.toLocaleString()
                          }}
                        </span>
                      </template>

                      <template v-slot:item.TotalQuantity="{ item }">
                        <span v-if="item.TotalQuantity >= 0">
                          {{
                            item.TotalQuantity.toLocaleString()
                          }}
                        </span>
                      </template>

                      <!-- <template v-slot:item.Item="{ item }">
                        <v-btn
                          color="primary"
                          text
                          @click="productsModal(item.Item.id)"
                          >{{ item.Item.Name
                          }}<v-icon small right>mdi-eye</v-icon></v-btn
                        >
                      </template>-->
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of products summary modal-->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import { http } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      IsDistributor: "",
      record: {},
      SalesReportData: {},
      loader: false,
      summaryDialog: false,
      pageItems: 2000,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      owner: null,
      owners: [],
      summaryData: [],
      outsourcedData: [],
      headers: [
        { text: "Invoice No.", value: "DocNum" },
        { text: "Product", value: "ProductName" },
        { text: "Qty", value: "Quantity" },
        { text: "UOM", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Customer", value: "CustomerName" },
        { text: "Phone No.", value: "customerPhone" },
        { text: "Payment Mode", value: "PaymentModes" },
        { text: "Owner", value: "OwnerName" },
        { text: "Imei", value: "Imei" },
        { text: "Sold By", value: "SoldBy" },
        { text: "Date", value: "Date" }
      ],
      summaryHeaders: [
        { text: "Item Name", value: "product" },
        { text: "Opening Stock", value: "openingQty" },
        { text: "Total Purchase", value: "totalBought" },
        { text: "Transfer In", value: "transIn" },
        { text: "Total Sold", value: "totalSold" },
        { text: "Transfer Out", value: "transOut" },
        { text: "Closing Stock", value: "closingQty" }
      ],
      outsourcedHeaders: [
        { text: "Invoice No.", value: "DocNum" },
        { text: "Item Name", value: "Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Unit", value: "UomName" },
        { text: "SellingPrice", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Customer", value: "invoice.Customer.Name" },
        { text: "Date", value: "Date" }
      ],
      fields: {
        product: "product",
        openingQty: "openingQty",
        totalGiven: "transIn",
        totalSold: "totalSold",
        closingQty: "closingQty"
      },
      returnHeaders: [
        { text: "Customer", value: "Customer.Name" },
        { text: "Product", value: "product.Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "User", value: "user.name" },
        { text: "Date", value: "DocDate" }
      ],
      soldProducts: [],
      totalSales: null,
      returnsData: [],
      TotalReturns: null
    };
  },
  computed: {
    hideTotalSales() {
      return localStorage.getItem("HideTotalSales");
    },
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    netSales() {
      const total = this.SalesReportData.TotalSales || 0;
      const returns = this.TotalReturns || 0;
      return total - returns;
    }
  },
  methods: {
        formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    setDate(date) {
      this.date = date;
    },
    thermalPrint() {
      const data = this.record;
      const url = "/stock-movement-analysis/available/14";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            let details = {
              storeName: self.storeName,
              stock: res.ResponseData,
              date: self.record.EndDate
            };
            self.printLocalInventory(details);
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printLocalInventory(stock) {
      return http.post(
        "http://localhost/stalispos-receipt/src/inventory/ClosingData.php",
        {
          stock
        }
      );
    },
    printSummary() {
      // const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      var totalPagesExp = "{total_pages_count_string}";
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      // doc.text(shopName, pageWidth - 50, 15, "center");

      //Setting Items Title:
      doc.setFontSize(15);
      doc.text("Stock Analysis Report", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        "From: " + "2020-10-01" + "   " + "To: " + "2020-10-15",
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataRows = [];

      // Columns
      var columns = [
        { title: "Product", dataKey: "product" },
        { title: "Opening Qty", dataKey: "openingQty" },
        { title: "Total Purchases", dataKey: "totalBought" },
        { title: "Transfer In", dataKey: "transIn" },
        { title: "Total Sales", dataKey: "totalSold" },
        { title: "Transfer Out", dataKey: "transOut" },
        { title: "Closing Qty", dataKey: "closingQty" }
      ];

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");

      const allData = this.summaryData;
      dataRows = allData.map(alldata => {
        return {
          product: alldata.product,
          openingQty: alldata.openingQty,
          totalBought: alldata.totalBought,
          transIn: alldata.transIn,
          totalSold: alldata.totalSold,
          transOut: alldata.transOut,
          closingQty: alldata.closingQty
        };
      });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("RECORDS", 15, 70);
      doc.autoTable(columns, dataRows, {
        theme: "grid",
        startY: 75,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
          //Setting Foouter
          doc.setTextColor(22, 160, 133);
          doc.setFontSize(10);
          var today = new Date();
          doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
        }
      });
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }
      window.open(doc.output("bloburl"), "_blank");
    },
    getReport() {
      const data = this.record;
      const url = "/stock-movement-analysis/14";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.summaryData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      const self = this;
      const DocDate = this.date;
      const data = {
        StartDate: DocDate,
        SoldBy: null,
        ProductID: null,
        CustomerID: null,
        combinedReport: "N",
        owner: self.owner
      };


      this.$store.commit("loader", true);

      var url = "";
      if (this.IsDistributor == "Y") {
        url = `/daily-distributor-sold-products-report`;
      }

      if (this.IsDistributor != "Y") {
        url = `/daily-sold-products-report`;
      }

      console.log(url, " sold products url");

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.SalesReportData = res.ResponseData;
            self.soldProducts = res.ResponseData.SoldProducts;
            self.totalSales = res.ResponseData.TotalSales;
            self.outsourcedData = res.ResponseData.OutsourcedSales;
            self.$store.commit("loader", false);
            self.returnedProducts();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    returnedProducts() {
      const data = {
        StartDate: this.date,
        EndDate: this.date,
        CustomerID: null
      };
      const self = this;
      const url = `/returned-products-report`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.returnsData = res.ResponseData.AllSales;
            self.TotalReturns = res.ResponseData.TotalReturns;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOwners() {
      const self = this;
      this.$store
        .dispatch("get", `/get-owner-users`)
        .then(res => {
          console.log(res.ResponseData);
          self.owners = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.IsDistributor = res.ResponseData.IsDistributor;
              self.getRecords();
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    checkExpiry() {
      const self = this;
      const userId = this.subscriberId;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          console.log(res.ResponseData, "res g");
          if (res.ResponseData.expiryStatus == 1) {
            self.$router.push("/inactive-account");
          }
        })
        .catch(() => { });
    },
  },
  created() {
    this.getOwners();
    this.getGenSettings();
    this.checkExpiry();
    this.returnedProducts();
  }
};
</script>

<style lang="scss" scoped></style>